import { mapGetters, mapMutations } from 'vuex';

export const FavoriteSelectBookMixin = {
  name: 'FavoriteSelectBookMixin',

  computed: {
    ...mapGetters('Mixins/Bookmark', {
      mg_selectedCourseBooks: 'selectedCourseBooks',
    }),
  },

  methods: {
    ...mapMutations('Mixins/Bookmark', {
      mm_SET_SELECTED_BOOK_ID: 'SET_SELECTED_BOOK_ID',
    }),

    selectBook(bookId) {
      this.mm_SET_SELECTED_BOOK_ID(bookId);
    },
  },
};
